<div class="container" [formGroup]="form">

  <div class="row mt-4">
    <div class="col-12">

      <!-- MODULE SELECTION -->
      <div class="mb-4">
        <h4 class="side-panel-label mb-2">Module Selection</h4>
        <div class="row">
          <div class="col-md-4 mb-3" *ngFor="let m of moduleList">
            <div class="toggle-block text-center">
              <label class="form-label d-block mb-2">{{ m.label }}</label>
              <div class="custm-toglbtn small-toggle">
                <input type="checkbox" [id]="m.key" [formControl]="form.get('modules')?.get(m.key)">
                <label [for]="m.key"></label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- CATEGORY SELECTION -->
      <div class="mb-4">
        <h4 class="side-panel-label mb-2">Category Selection</h4>
        <div class="row">
          <div class="col-md-4 mb-3" *ngFor="let c of categoryList">
            <div class="toggle-block text-center">
              <label class="form-label d-block mb-2">{{ c.label }}</label>
              <div class="custm-toglbtn small-toggle">
                <input type="checkbox" [id]="c.key" [formControl]="form.get('categories')?.get(c.key)">
                <label [for]="c.key"></label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- COMMUNICATION PREFERENCE -->
      <div class="mb-4">
        <h4 class="side-panel-label mb-2">Communication Preference</h4>

        <div class="row">
          <div class="col-md-4 mb-3">
            <div class="toggle-block text-center">
              <label class="form-label d-block mb-2">Email</label>
              <span
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Email is the default communication mode and cannot be disabled"
                class="d-inline-block">
                 <div class="custm-toglbtn small-toggle">
                   <input type="checkbox" id="email" [formControl]="form.get('notificationPreferences')?.get('EMAIL')">
                   <label for="email"></label>
                 </div>
              </span>
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <div class="toggle-block text-center">
              <label class="form-label d-block mb-2">SMS</label>
              <div class="custm-toglbtn small-toggle">
                <input type="checkbox" id="sms" [formControl]="form.get('notificationPreferences')?.get('SMS')">
                <label for="sms"></label>
              </div>
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <div class="toggle-block text-center">
              <label class="form-label d-block mb-2">WhatsApp</label>
              <div class="custm-toglbtn small-toggle">
                <input type="checkbox" id="whatsapp"
                       [formControl]="form.get('notificationPreferences')?.get('WHATSAPP')">
                <label for="whatsapp"></label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--<div class="row">

        &lt;!&ndash; Query TAT &ndash;&gt;
        <div class="col-md-4 mb-4">
          <h4 class="side-panel-label mb-2">Query TAT</h4>
          <select class="form-select" formControlName="queryTat">
            <option *ngFor="let o of queryTatOptions" [value]="o">{{ o }}</option>
          </select>
        </div>

        &lt;!&ndash; Activity List &ndash;&gt;
        <div class="col-md-4 mb-4">
          <h4 class="side-panel-label mb-2">Activity List</h4>
          <select class="form-select"
                  formControlName="activityListType"
                  (change)="onActivityListChange()">
            <option *ngFor="let o of activityListOptions" [value]="o">{{ o }}</option>
          </select>
        </div>

        &lt;!&ndash; Upload (Custom Only) &ndash;&gt;
        <div class="col-md-4 mb-4" *ngIf="form.get('activityListType')?.value === 'Custom'">
          <h4 class="side-panel-label mb-2">Upload Custom</h4>
          <input type="file" class="form-control" formControlName="uploadFile">
        </div>

      </div>-->

      <!-- RMS Admins -->
      <div class="row">
        <div class="col-md-6 mb-4">
          <h4 class="side-panel-label mb-2">Assign RMS Admins</h4>
          <tag-input
            formControlName="rmsAdminUserIds"
            [onlyFromAutocomplete]="true"
            [identifyBy]="'value'"
            [displayBy]="'display'"
          >
            <tag-input-dropdown
              [autocompleteItems]="rmsAdminOptions"
              [showDropdownIfEmpty]="true"
              [minimumTextLength]="3">
            </tag-input-dropdown>
          </tag-input>

        </div>
      </div>

    </div>
  </div>

  <!-- FOOTER -->
  <div class="d-flex justify-content-end gap-2 mt-4">
    <button class="btn btn-primary" (click)="next()">Save & Next</button>
  </div>

</div>
